async function downloadFile({ url, name, extension }) {
  let nameFormatted = name
  if (extension) {
    nameFormatted = `${name}.${extension}`
  } else {
    const urlExtension = url.split('?')[0].split('#')[0].split('.').pop()
    if (urlExtension) {
      nameFormatted = `${name}.${urlExtension}`
    }
  }

  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = blobUrl
      anchor.download = nameFormatted
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      URL.revokeObjectURL(blobUrl) // Clean up the blob URL
    })
    .catch((error) => console.error('Error downloading file:', error))
}

export {
  // eslint-disable-next-line import/prefer-default-export
  downloadFile
}
